// extracted by mini-css-extract-plugin
export default {"spinner":"PrimarySpinner_spinner__eVIZV","spin":"PrimarySpinner_spin__1qiFV"};